// theme.js
export const lightTheme = {
  body: '#fff !important'
}

export const darkTheme = {
  body: '#600079 !important'
}
